import React, {Component} from 'react'
import * as config from '../Configuration/Config.js'
import * as pbi from 'powerbi-client';
import * as models from 'powerbi-models';
import {isMobile} from 'react-device-detect';
import UserProfile from '../Configuration/UserProfile'
import { Helmet } from 'react-helmet'
// import qs from 'query-string';

class VisualizationView extends Component {
  constructor() {
    super();
    this.state = {
        is_loaded: false,
        reportinfo: null        
    }
    
  }
    componentDidMount() {
        const rid = this.props.match.params.rid;
        const gid = this.props.match.params.gid;
        const uri = config.getUriPath('visualizations/embedToken?id=' + rid + '&group_id=' + gid)

        this.profile = new UserProfile();        
        var varCustomerId = this.profile.CustomerId();
        //console.log('View varCustomerId: ' + varCustomerId);

        //customerinfo
        var that = this;        
        const uricst = config.getUriPath('customers/' + varCustomerId)
        var varCustomerCustomWorkspace = ''; 
        fetch(uricst, {
            method: 'get',
            headers: config.ApiHeaders()
           }).then(function(response) {
            if (response.status >= 400) {
              throw new Error("Bad response from server");
            }
            return response.json();
          })
          .then(function(data) {           
            //console.log(data);
            if(data.customer_group_id.toLowerCase() !== gid.toLowerCase())
            {
              console.log("Invalid Group ID");
              return null;
            }            
        });

        //report info
        var reportname = ''
        
        let vizuri = config.getAcumenAPIURL('reports/' + rid);        
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        myHeaders.append("x-api-key", config.getAcumenAPIKey()); 
        myHeaders.append("table-prefix", config.getTablePrefix()); 
        
        fetch(vizuri, {
                method: 'get',
                headers: myHeaders
               }).then(function(response) {
                    if (response.status >= 400) {
                    throw new Error("Bad response from server");
                    }
                    return response.json();
              })
              .then(function(data) {
               console.log('report info loaded')               
               reportname = data.report.name;
               that.setState({ is_loaded: true, reportinfo: data.report });                   
               return;
            });
                    
            
        const mobileLayout = models.LayoutType.MobilePortrait;
        const desktopLayout = models.LayoutType.Custom;
        var thisLayout = desktopLayout;
        if (isMobile) {
            thisLayout = mobileLayout;
        }
        var v_viewMode = models.ViewMode.View;
        var v_Permissions = models.Permissions.All;

        //embed token
        fetch(uri, {
            method: 'get',
            headers: config.ApiHeaders()
           }).then(function(response) {
            if (response.status >= 400) {
              throw new Error("Bad response from server");
            }

            if (response.status >= 204) {
                return null;
            }

            return response.json();
          })
          .then(function(data) {
            if (data == null) {
                return;
            }

            const embedUrl = "https://app.powerbi.com/reportEmbed?reportId=" + rid + "&groupId=" + gid;

            var pbiconfig = {
                type: 'report',
                tokenType: 1,
                accessToken: data.token,
                embedUrl: embedUrl,
                id: rid,
                permissions: v_Permissions,
                viewMode: v_viewMode,
                settings: {
                  filterPaneEnabled: true,
                  navContentPaneEnabled: true,
                  //background: 1,                  
                  layoutType: thisLayout,
                  panes: {
                    pageNavigation: {visible: true, position: 1}
                    }
                  }
                };

                let powerbi = new pbi.service.Service(pbi.factories.hpmFactory, pbi.factories.wpmpFactory, pbi.factories.routerFactory);
                var reportContainer = document.getElementById('rptContainer');
                
               var report = powerbi.embed(reportContainer, pbiconfig); 
               report.on("saved", function (event) {
                 console.log(event.detail);
                 if (event.detail.saveAs) {
                    console.log('redirect to new report');
                 }
               });
               report.on("loaded", function (event) {
                document.title = reportname;
               });
               report.on("error", function (event) {
                console.log(event.detail);                
               });   
          });
          
    }

    render() {            
        return    <div>                   
                    <div className="center-div">
                        <div className="rptContainer" id="rptContainer">&nbsp;</div>
                    </div>
                </div>
    }
}

export default VisualizationView


// WEBPACK FOOTER //
// ./src/Components/Visualizations/VisualizationView.js